module.exports = __webpack_public_path__ + "media/honey-icons/icon-signal-booster-plug-bf5b4321.svg";